import {FetchBaseQueryError} from '@reduxjs/toolkit/query';
import {DefaultRootState} from 'react-redux';

import {
  setCookieAuthError,
  setTokenAuthError,
  TokenAuthErrorType,
} from 'app/auth/slice';
import {AppDispatchType} from 'app/store/AppStore';

interface ErrorDetail {
  detail: string;
}

interface TokenError {
  status: 403;
  data: ErrorDetail;
}

export function captureTokenAuthError(
  responseError: FetchBaseQueryError,
  api: {dispatch: AppDispatchType; getState: () => unknown},
  filterBy: Array<TokenAuthErrorType> = [
    'invalid-token',
    'inactive-user',
    'required-not-in-scope',
  ]
) {
  const authType = (api.getState() as DefaultRootState).auth.type;

  const errorLookup: Record<string, TokenAuthErrorType> = {
    'Token expired.': 'invalid-token',
    'Invalid token.': 'invalid-token',
    'User inactive or deleted.': 'inactive-user',
    'Not in scope.': 'required-not-in-scope',
  };

  if (authType === 'token' && isTokenError(responseError)) {
    const detail: string = responseError.data.detail;
    const error: TokenAuthErrorType | null = errorLookup[detail] || null;

    if (error && filterBy.includes(error)) {
      // dispatch the error if it exists and is in filterBy
      api.dispatch(setTokenAuthError(error));
    }
  }
}

const isTokenError = (error: FetchBaseQueryError): error is TokenError =>
  error.status === 403 && 'detail' in (error.data as ErrorDetail);

export function captureCookieAuthError(
  responseError: FetchBaseQueryError,
  api: {dispatch: AppDispatchType; getState: () => unknown}
): void {
  const authType = (api.getState() as DefaultRootState).auth.type;

  if (
    authType === 'session-cookie' &&
    responseError.status === 403 &&
    'data' in responseError &&
    (responseError.data as any).detail_code === 'not_authenticated'
  ) {
    api.dispatch(setCookieAuthError('not-authenticated'));
  }
}
